import React from "react"
import Layout from "../layout/Layout"
import SEO from "../components/seo"
import PageHeaderTitle from "../components/PageHeaderTitle/PageHeaderTitle"
import TransactionSteps from "../components/TransactionSteps/TransactionSteps"

class RulesOrderPage extends React.Component {
  render() {
    return (
      <Layout>
        <SEO
          title="Przeprowadzone realizacje"
          ratingCount={16} ratingValue={4.8}
        />
        <PageHeaderTitle text="Przeprowadzone realizacje" />
        <TransactionSteps />
      </Layout>
    )
  }
}

export default RulesOrderPage
